import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import {
  MarginDiv,
  GrayDarkerServiceSpan,
  GraySpan,
  GrayDarkerSpan,
} from "./QuoteItems.styled";
import { GridRow } from "../../QuoteList.styled";
import "../../QuoteList.scss";
import {
  renderPriceWithCurrency,
  renderPriceWithCurrencyWithoutUnit,
  addSpace,
} from "@utils/utils";

const QuoteItems = (props) => {
  const { t, itemList, enquiryId, sellingPriceId, currency } = props;

  return (
    <>
      {itemList?.length > 0 &&
        itemList.map((item, itemIndex) => {
          return (
            <React.Fragment key={"quote-item" + item?.id + itemIndex}>
              <GridRow
                column="52% 1fr 1fr 1fr"
                marginBottom="10px"
                marginRight="10px"
              >
                <MarginDiv marginLeft="30px">
                  <GrayDarkerServiceSpan weight="700">
                    {String(item?.label) || ""}&nbsp;
                  </GrayDarkerServiceSpan>
                  <GraySpan>
                    {item.hesusService.needProduct && item.product.name}
                    {item.hesusService.needProduct &&
                      item.hesusService.needTransport &&
                      " - "}
                    {item.hesusService.needTransport && item.transport.name}
                  </GraySpan>
                </MarginDiv>
                <GraySpan textAlign="center">
                  {item.quantity + " " + t(item?.unit)}
                </GraySpan>
                <GraySpan textAlign="center">
                  {renderPriceWithCurrency(
                    addSpace(item?.itemSellingPrice),
                    t(item?.unit),
                    currency?.symbol,
                    currency?.position
                  )}
                </GraySpan>
                <GrayDarkerSpan textAlign="right" weight="700">
                  {renderPriceWithCurrencyWithoutUnit(
                    addSpace(item?.sellingPriceExcludedTax),
                    currency?.symbol,
                    currency?.position
                  )}
                </GrayDarkerSpan>
              </GridRow>
            </React.Fragment>
          );
        })}
    </>
  );
};

QuoteItems.propTypes = {
  t: PropTypes.func.isRequired,
};
QuoteItems.defaultProps = {};

export default withTranslation()(QuoteItems);
